var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-header-inner"},[_c('h1',{staticClass:"content-header-title"},[_vm._v("404: Page not found")]),_c('p',[_vm._v("Sorry this page could not be found")])])])])
}]

export { render, staticRenderFns }